export default (entities) => ({
  getInvoices(organisationId) {
    return entities.Invoice.findAll(organisationId);
  },
});
